import { render, staticRenderFns } from "./add-reviewer.dialog.vue?vue&type=template&id=776bde8c&scoped=true"
import script from "./add-reviewer.dialog.vue?vue&type=script&lang=js"
export * from "./add-reviewer.dialog.vue?vue&type=script&lang=js"
import style0 from "./add-reviewer.dialog.vue?vue&type=style&index=0&id=776bde8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776bde8c",
  null
  
)

export default component.exports